import React from 'react';
import { motion } from 'framer-motion';
import { Star, Quote } from 'lucide-react';
const reviews = [{
  text: '非常专业的服务，环境优雅，技师手法一流。在这里度过了一个非常放松的下午，强烈推荐！',
  author: 'Mr. Zhang',
  role: 'Business Executive',
  rating: 5
}, {
  text: 'Excellent service and privacy. The therapists are highly skilled and professional. Will definitely come back again.',
  author: 'James L.',
  role: 'Regular Client',
  rating: 5
}, {
  text: '体验非常棒，从预约到服务都很顺畅。伴游服务非常贴心，让我的商务行程不再枯燥。',
  author: '王先生',
  role: 'Entrepreneur',
  rating: 5
}, {
  text: '由于工作繁忙，我经常预约他们的上门按摩服务。精油按摩的手法非常地道，每次都能让我彻底放松，强烈推荐给在新加坡的朋友。',
  author: '李女士',
  role: 'Marketing Director',
  rating: 5
}, {
  text: 'The best Singapore massage I have ever experienced. The professional service and attention to detail are truly outstanding.',
  author: 'David S.',
  role: 'Tourist',
  rating: 5
}, {
  text: '凌晨刚到新加坡，幸好他们提供24小时服务。预约了酒店按摩，技师很快就到了，服务态度极好，解除了我一路的疲惫。',
  author: '陈先生',
  role: 'Frequent Traveler',
  rating: 5
}];
export function Testimonials() {
  return <section id="testimonials" className="py-24 bg-[#faf7f2] relative" data-id="element-199">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-200">
        <div className="text-center mb-16" data-id="element-201">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} data-id="element-202">
            <h2 className="text-4xl md:text-5xl font-serif font-bold text-[#1a1a2e] mb-4" data-id="element-203">
              客户评价
            </h2>
            <p className="text-[#c9a96e] uppercase tracking-widest font-medium" data-id="element-204">
              Client Testimonials
            </p>
          </motion.div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-205">
          {reviews.map((review, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-white p-8 rounded-sm shadow-sm border border-gray-100 relative" data-id="element-206">
              <Quote className="absolute top-6 right-6 text-[#c9a96e]/20" size={48} data-id="element-207" />

              <div className="flex mb-4" data-id="element-208">
                {[...Array(review.rating)].map((_, i) => <Star key={i} size={16} className="text-[#c9a96e]" fill="currentColor" data-id="element-209" />)}
              </div>

              <p className="text-gray-600 italic mb-6 leading-relaxed min-h-[80px]" data-id="element-210">
                "{review.text}"
              </p>

              <div className="flex items-center" data-id="element-211">
                <div className="w-10 h-10 rounded-full bg-gray-200 flex items-center justify-center text-gray-500 font-serif font-bold" data-id="element-212">
                  {review.author.charAt(0)}
                </div>
                <div className="ml-3" data-id="element-213">
                  <p className="text-sm font-bold text-[#1a1a2e]" data-id="element-214">
                    {review.author}
                  </p>
                  <p className="text-xs text-gray-400 uppercase tracking-wide" data-id="element-215">
                    {review.role}
                  </p>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}